module.exports = {
  title: '分类管理',
  route: {
    path: '/content-manage',
    children: {
      path: 'help-classfy-manage',
    },
  },
};
